/**
 * Returns a new empty array.
 *
 * @returns {Array} A new empty array.
 * @example
 * stubArray() // Returns []
 */
export function stubArray(): [] {
  return [];
}
